@if (selectedChannel(); as channel) { @if (channel.messagesStartDate && channel.messagesCompleted &&
channel.hasOldMessagesToLoad) {
<div class="old-messages-banner" (click)="loadOldMessages()">
  <div class="old-messages-banner__content">Click here to see messages from prior visits.</div>
</div>
} }
